import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=3153f689&"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports